import { render, staticRenderFns } from "./xwDetail.vue?vue&type=template&id=0ba89806&scoped=true&"
import script from "./xwDetail.vue?vue&type=script&lang=js&"
export * from "./xwDetail.vue?vue&type=script&lang=js&"
import style0 from "./xwDetail.vue?vue&type=style&index=0&id=0ba89806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba89806",
  null
  
)

export default component.exports